"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var SearchAndFilter_1 = __importDefault(require("atomicComponents/organisms/SearchAndFilter"));
var constants_1 = require("./constants");
var context_1 = require("./context");
var RechargesDropdown_1 = __importDefault(require("./RechargesDropdown"));
var utils_1 = require("./utils");
var RechargesSearchAndFilter = function (_a) {
    var recharges = _a.recharges, filteredRecharges = _a.filteredRecharges, selectedFilters = _a.selectedFilters, setSelectedFilters = _a.setSelectedFilters, searchText = _a.searchText, setSearchText = _a.setSearchText;
    var opts = utils_1.filterGroupDefinitions.map(function (_a) {
        var makeOptions = _a.makeOptions;
        return makeOptions(recharges);
    }).flat();
    var _b = (0, context_1.useSelectedRecharges)(), setSelectedIds = _b.setSelectedIds, selectedIds = _b.selectedIds;
    var firstSelectedRecharge = filteredRecharges.find(function (r) { return r.id === selectedIds[0]; });
    var selectAllSelectable = function () {
        var selectableRechargesIds = filteredRecharges
            .filter(function (r) { return r.isExcluded === (firstSelectedRecharge === null || firstSelectedRecharge === void 0 ? void 0 : firstSelectedRecharge.isExcluded) && !constants_1.NON_ACTIONABLE_STATES.includes(r.rechargerStatus); })
            .map(function (r) { return r.id; });
        setSelectedIds(selectableRechargesIds);
    };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", justifyContent: "flex-end", px: 4 }, { children: [firstSelectedRecharge && (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ size: "small", sx: { mr: 1 }, onClick: selectAllSelectable }, { children: "Select all" })), (0, jsx_runtime_1.jsx)(SearchAndFilter_1.default, { searchProperties: { searchText: searchText, setSearchText: setSearchText }, filterProperties: { options: opts, results: selectedFilters, setResults: setSelectedFilters } }), (0, jsx_runtime_1.jsx)(RechargesDropdown_1.default, { recharges: recharges })] })));
};
exports.default = react_1.default.memo(RechargesSearchAndFilter);
